import React from 'react';
import PropTypes from 'prop-types';

const ButtonBoxComponent = ({ style, hidden = false, children }) => {
  if (hidden) return null;

  return (
    <div className={`intro-y box p-5 col-md-${style}`}>
      <div className="mb-4">
        {children}
      </div>
    </div>
  );
};

ButtonBoxComponent.propTypes = {
  style: PropTypes.string,
  hidden: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default ButtonBoxComponent;
